import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Logo from "../../assets/images/logos/logo.webp";
import PathConstants from "../../routes/pathConstants";
import SocialLinks from "../social-links";
import { Styles } from "./styles";
import { Col, Row } from "react-bootstrap";
import EngraveImage from "../../assets/images/icons/engrave.png";
import { useTranslation } from "react-i18next";
import { selectSettings } from "../../store/settings/settingsSlice";

const Footer = ({ backgroundColor = null }) => {
  const { t } = useTranslation();
  const settings = useSelector(selectSettings);

  const footerSections = [
    {
      title: t("Footer Platform Title"),
      links: [
        { label: t("Footer About"), to: PathConstants.ABOUT_US },
        { label: t("Footer Statistics"), to: PathConstants.ACHIEVEMENTS },
        { label: t("Footer Partnerships"), to: PathConstants.PARTNERS_AND_TEAM },
      ],
    },
    {
      title: t("Footer Important Links"),
      links: [
        { label: t("Projects"), to: PathConstants.PROJECTS },
        { label: t("Campaigns"), to: PathConstants.ACTIVE_CAMPAIGNS },
      ],
    },
    {
      title: t("Footer Legal"),
      links: [
        { label: t("Terms of Use"), to: "/" },
        { label: t("Privacy Policy"), to: "/" },
        { label: t("Contact us"), to: PathConstants.CONTACT_US },
      ],
    },
  ];

  const renderFooterColumn = (section, sectionIndex) => (
    <Col sm={4} md={4} lg={4} className="footer-col" key={`${section.title}-${sectionIndex}`}>
      <h4>{section.title}</h4>
      <ul>
        {section.links.map((link, linkIndex) => (
          <li key={`${link.label}-${linkIndex}`}>
            <Link to={link.to}>{link.label}</Link>
          </li>
        ))}
      </ul>
    </Col>
  );

  return (
    <Styles backgroundColor={backgroundColor}>
      <div className="container footer-inner">
        <Row className="footer-main">
          <Col sm={4} md={4} lg={4} className="footer-brand">
            <img src={Logo} alt="Naqsh" className="footer-logo" />
            <p className="footer-tagline">{t("Footer Tagline")}</p>
            <div className="footer-social">
              <SocialLinks
                share={false}
                color="#edf5f7"
                backgroundColor="transparent"
                size="1rem"
                socialData={{
                  LinkedInLink: settings?.ContactUsLinkedInLink,
                  XLink: settings?.ContactUsXLink,
                  YoutubeLink: settings?.ContactUsYouTubeLink,
                  FacebookLink: settings?.ContactUsFacebookLink,
                  InstagramLink: settings?.ContactUsInstagramLink,
                }}
              />
            </div>
          </Col>
          <Col sm={8} md={8} lg={8} className="footer-columns row">
            {footerSections.map(renderFooterColumn)}
          </Col>
        </Row>
        <div className="footer-bottom">
          <img src={EngraveImage} alt="Engrave" className="engrave-image" />
          <span>{t("Footer Copyright")}</span>
          <span>
            {t("Footer Made By")} <span className="footer-author">DigiSou</span>
          </span>
        </div>
      </div>
    </Styles>
  );
};

export default Footer;
